import { cva as e } from "class-variance-authority";
// src/design/list-screen/style.ts
var t = e("w-full"), n = e("mt-0 min-w-0 pt-4"), r = e("flex min-w-0 flex-col gap-4"), i = () => ({
	filters: t,
	tabPanel: n,
	tabPanelBody: r
});
export { i as getStyles };

//# sourceMappingURL=style.js.map